import styled from "styled-components";

export const FeedContainer = styled.main`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2rem 4%;
  background: #fef9fa;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1.4rem 4%;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #fef9fa;
`;

export const ContentWrapper = styled.div`
  margin: 0 auto;
  padding: 2rem 3%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2.5rem;

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 1.4rem 5%;
  }
`;

export const LeftColumn = styled.section`
  flex: 0 1 60%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 900px) {
    flex: 1 1 auto;
    width: 100%;
  }
`;

export const RightColumn = styled.aside`
  flex: 0 1 35%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const Tabs = styled.div`
  display: flex;
  gap: 3rem;
  margin-bottom: 1.2rem;
`;

export const Tab = styled.button<{ active: boolean }>`
  background: none;
  border: none;
  font: 600 1.2rem/1 "Inter", sans-serif;
  color: ${({ active }) => (active ? "#fe2f67" : "#444")};
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -3px;
    height: 2.5px;
    border-radius: 2px;
    background: #fe2f67;
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.25s;
  }
`;
